import type { schemaType as HolidaysSchemaType } from '~~/modules/api/strapi/vacaciones-landings/list/schema'
import type { schemaType as VillagesSchemaType } from '~~/modules/api/strapi/pueblos-landings/list/schema'
import type { schemaType as EscapadasListSchemaType } from '~~/modules/api/strapi/escapadas/list/schema'
import type { schemaType as EscapadasDetailSchemaType } from '~~/modules/api/strapi/escapadas/detail/schema'
import type { propsInterface } from '~~/modules/design-system/sections/s-links/s-links.vue'

export const useToSLinks = () => {
  const fromStrapiHolidaysList = (params: {
    dataIn: HolidaysSchemaType
    filterName?: string
  }) => {
    let items: propsInterface['items'] = []

    let rawData = params.dataIn

    if (params.filterName) {
      rawData = rawData.filter(
        link => link.attributes.name !== params.filterName,
      )
    }

    items = rawData.map(item => {
      return {
        name: item.attributes.name,
        href: routes().holidaysDetail({ slug: item.attributes.slug }),
      }
    })

    return { items }
  }

  const fromStrapiVillagesList = (params: {
    dataIn: VillagesSchemaType
    filterName?: string
  }) => {
    let items: propsInterface['items'] = []

    let rawData = params.dataIn

    if (params.filterName) {
      rawData = rawData.filter(
        link => link.attributes.name !== params.filterName,
      )
    }

    items = rawData.map(item => {
      return {
        name: item.attributes.name,
        href: routes().villagesDetail({ slug: item.attributes.slug }),
      }
    })

    return { items }
  }

  const fromHomeLinks: (
    dataIn: Array<{ name: string; slug: string }>,
  ) => propsInterface['items'] = data => {
    return data.map(item => {
      return {
        name: item.name,
        href: routes().cottageDefinedList({ slug: item.slug }),
      }
    })
  }

  const fromStrapiEscapadasList = (params: {
    dataIn: EscapadasListSchemaType
  }) => {
    let items: propsInterface['items'] = []

    items = params.dataIn
      .filter(item => {
        return item.attributes.publishedAt
      })
      .map(item => {
        return {
          name: item.attributes.title,
          href: routes().escapadasDetail({ slug: item.attributes.slug }),
        }
      })

    return items
  }

  const fromStrapiEscapadasDetail = (params: {
    dataIn: EscapadasDetailSchemaType
  }) => {
    let items: propsInterface['items'] = []

    if (params.dataIn.attributes.seo_links) {
      items = params.dataIn.attributes.seo_links.flatMap(item =>
        item.link.map(link => ({
          name: link.text,
          href: link.url,
        })),
      )
    }

    return items
  }

  return {
    fromStrapiHolidaysList,
    fromStrapiVillagesList,
    fromStrapiEscapadasList,
    fromStrapiEscapadasDetail,
    fromHomeLinks,
  }
}
